import React from 'react';
import {colors} from '@xpertdox_js/xdstyle';
import axiosConfig from "../config/axios.config";
import axios from "axios";

const {apiUrl} = axiosConfig;

const styles = {
  container: {
    backgroundColor: colors.lightBlue,
    padding: 5,
    textAlign: 'center',
    cursor: 'pointer',
    borderBottom: '1px solid rgb(218, 220, 222)',
    color: colors.darkGray
  },
  msg: {
    margin: 0,
    fontWeight: 'bold',
    fontSize: '1.4rem'
  }
}

const MsgBanner = (props) => {
  const [actions, setActions] = React.useState(false)
  const [hover, setHover] = React.useState(false)
  const {type} = props;
  const [mounted, setMounted] = React.useState(false);
  React.useEffect(() => {
    if(!mounted) setMounted(true)
    return () => setMounted(false)
  }, []);

  if(!actions && mounted) axios.get(`${apiUrl}/rt/fetch-banner-actions/${props.user.id}`)
    .then(userActions => {
      setActions(userActions.data)
    }).catch(err => console.log('fetch-banner-error', err))

  const content = {
    editField: 'Click on any field to edit',
    trialFilters: 'Age, gender, phase, healthy volunteer, primary purpose, ECOG, mutations, treatment status, suggested conditions, and disease stage need full database update to be reflected on the XpertScreen and XpertTrial platforms',
    xpertTriage: 'Click on the folder icon in the left most column to select patients and move them to a folder',
    filterPanel: 'Any edits made on this page will reflect on XpertScreen and XpertTrial after the next database update',
    studyLocation: 'Click on a location to edit or add locations to a study',
    studyContacts: 'Click on a contact to edit or add study contacts',
    specialtyContacts: 'Click on a contact to edit or add specialty contacts',
    allTrials: 'Click on a trial to view and edit trials information'
  }

  const handleClick = e => axios.post(`${apiUrl}/rt/save-banner-actions`, {
    user: props.user.id,
    type
  }).then(updatedActions => setActions(updatedActions.data)).catch(err => console.log(err))

  const avail = content[type] || props.content

  let containerStyles = styles.container;
  if(props.customColor) containerStyles = {...containerStyles, backgroundColor: props.customColor.background, color: props.customColor.text}

  if(avail && actions && !actions[type]) {
    if(props.removable) return <div
        onMouseEnter={() => setHover(true)}
        onMouseLeave={() => setHover(false)}
        onClick={e => handleClick(e)}
        style={containerStyles}
    >
      <p style={styles.msg}>{hover ? 'Clear message' : props.content || content[type]}</p>
    </div>
    else return <div style={containerStyles}>
      <p style={styles.msg}>{props.content || content[type]}</p>
    </div>
  }
  else return null
}

export default MsgBanner;
